module.exports = __webpack_public_path__ + "static/media/senderid.0b4963e3.svg";